/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */

import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import QueryString from 'qs';
import { useSnackbar } from 'notistack';
import { Alert, Button, Slide, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import { forwardRef } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import FormProvider from '../hook-form/form-provider';
import { encryptRequest, decryptResponse } from '@/app/utilities/helpers/security';
import { axiosInstance } from '@/app/utilities/helpers/axios';
import { useBoolean } from '../hooks/use-boolean';
import ControlledCheckbox from '../hook-form/check-box';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function PayPalPaymentModal({ device, tier, pCount }) {
  const { enqueueSnackbar } = useSnackbar();

  const Schema = Yup.object().shape({
    agreeTo: Yup.boolean()
      .oneOf([true], 'You must agree to proceed.')
      .required('You must agree to proceed.'),
  });

  const defaultValues = {
    agreeTo: false,
  };

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });
  const dialog = useBoolean();

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async () => {
    try {
      if (device.is_trial === 2) {
        enqueueSnackbar('You already purchased Lifetime membership', { variant: 'error' });
        return;
      }

      if (device.is_trial === 1 && tier.tier === 1) {
        enqueueSnackbar('You already purchased 1 year membership', { variant: 'error' });
        return;
      }

      const body = {
        data: encryptRequest({
          device_id: device._id,
          payment_type: 'paypal',
          tier_price: tier.discount ?? tier.price,
          tier: tier.tier,
          success: 'https://xciptvultra.com/checkout/success',
          fail: 'https://xciptvultra.com/contact-us',
          app_name: device?.app_name ?? 'xciptvsmartplayer',
        }),
      };

      const response = await axiosInstance.post(
        'vTGhG2j0ryuKzoZCQ1aupvkkpabSBzV0',
        QueryString.stringify(body)
      );

      const responseData = decryptResponse(response.data);

      if (responseData.success) {
        window.location.href = responseData.approvalUrl;
      } else {
        enqueueSnackbar(responseData?.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Server Error', { variant: 'error' });
    }
  });

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        sx={{ borderRadius: '16px', minWidth: '200px' }}
        onClick={() => {
          dialog.onTrue();
        }}
      >
        Pay With Card
      </Button>
      <Dialog
        keepMounted={false}
        open={dialog.value}
        onClose={dialog.onFalse}
        scroll="body"
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <FormProvider methods={methods} onSubmit={onSubmit}>
          <DialogTitle
            sx={{
              pb: 2,
              textAlign: {
                xs: 'center',
                sm: 'left',
              },
            }}
          >
            Are you sure you want to proceed with the payment?
          </DialogTitle>
          <DialogContent>
            <Stack gap={1} marginTop={2}>
              {pCount === 0 ? (
                <Alert severity="error" variant="outlined">
                  Please add your playlist first, and proceed with the payment only if you are
                  satisfied with my app.
                </Alert>
              ) : (
                <Alert severity="success" variant="outlined">
                  You have already added a playlist and confirmed that it is functioning correctly.
                </Alert>
              )}
              <ControlledCheckbox
                name="agreeTo"
                label="By clicking below, you agree to proceed with the payment process."
                disabled={pCount === 0}
              />

              <Stack gap={3} flexDirection="row" justifyContent="flex-end" marginBottom={2}>
                <Button onClick={dialog.onFalse}>Cancel</Button>
                <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
                  Pay
                </LoadingButton>
              </Stack>
            </Stack>
          </DialogContent>
        </FormProvider>
      </Dialog>
    </>
  );
}
